import { cachedSessionStorage } from '../cachedSessionStorage';

export const UTM_HEADER_BY_KEY = {
  source: 'x-tg-utm-source',
  medium: 'x-tg-utm-medium',
  campaign: 'x-tg-utm-campaign',
  term: 'x-tg-utm-term',
  content: 'x-tg-utm-content',
  adgroup: 'x-tg-utm-adgroup',
} as const;

/**
 * Builds the X-TG-UTM-* request headers from the cached UTM values.
 *
 * The referralId-over-utm_source precedence is already resolved into `source`
 * by SessionStorage.storeUTM, so the resulting `source` is sent through
 * X-TG-UTM-Source and referralId does not need to be sent separately.
 *
 * Missing or empty values do not produce a header.
 */
export const getUTMHeaders = (): Record<string, string> => {
  const utm = cachedSessionStorage.getUTM();
  const headers: Record<string, string> = {};

  Object.entries(utm).forEach(([key, value]) => {
    const headerName = UTM_HEADER_BY_KEY[key as keyof typeof UTM_HEADER_BY_KEY];

    if (headerName && value) {
      headers[headerName] = value;
    }
  });

  return headers;
};
